var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.0112 0 4.8 3.21418 4.8 7.20667V12.0111C2.16 12.0111 0 14.1731 0 16.8156V26.4245C0 29.0669 2.16 31.2289 4.8 31.2289H19.2C21.84 31.2289 24 29.0669 24 26.4245V16.8156C24 14.1731 21.84 12.0111 19.2 12.0111H7.2V7.20667C7.2 4.47294 9.2688 2.40222 12 2.40222C14.7312 2.40222 16.8 4.47294 16.8 7.20667V12.3596H19.2V7.20667C19.2 3.21418 15.9888 0 12 0ZM12 18.0167C13.32 18.0167 14.4 19.0977 14.4 20.4189C14.4 21.2597 13.92 22.0848 13.2 22.4464V25.2234C13.2 25.944 12.72 26.4245 12 26.4245C11.28 26.4245 10.8 25.944 10.8 25.2234V22.4452C10.08 22.0849 9.6 21.2597 9.6 20.4189C9.6 19.0977 10.68 18.0167 12 18.0167Z",
    fill: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.73973ca67c5a1d1d18bfc2de56de8273.svg";
export { ForwardRef as ReactComponent };